export const blockIconsAudioandvideoLibraryMusicNew = (
	<span className='material-symbols-outlined'>library_music</span>
);
